<template>
  <div class="office-shell">
    <div class="office-nav">
      <div class="office-tabs">
        <button class="office-tab" :class="{ active: tab === 'fornecedores' }" @click="tab = 'fornecedores'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
          Fornecedores
        </button>
        <button class="office-tab" :class="{ active: tab === 'nf' }" @click="tab = 'nf'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          Notas Fiscais
        </button>
        <button class="office-tab" :class="{ active: tab === 'rc' }" @click="tab = 'rc'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          Req. de Compra
        </button>
        <button class="office-tab" :class="{ active: tab === 'oc' }" @click="tab = 'oc'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
          Ordens de Compra
        </button>
        <button class="office-tab" :class="{ active: tab === 'cc' }" @click="tab = 'cc'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
          Centro de Custo
        </button>
        <button class="office-tab" :class="{ active: tab === 'questionarios' }" @click="tab = 'questionarios'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          Questionários
        </button>
        <button class="office-tab" :class="{ active: tab === 'gerencia' }" @click="tab = 'gerencia'" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
          Gerenciar Escritório
        </button>
      </div>
    </div>

    <div class="office-content">
      <OfficeFornecedoresTab v-if="tab === 'fornecedores'" />
      <OfficeNotasFiscaisTab v-else-if="tab === 'nf'" />
      <OfficeRequisicaoCompraTab v-else-if="tab === 'rc'" />
      <OfficeOrdemCompraTab v-else-if="tab === 'oc'" />
      <OfficeCentroCustoTab v-else-if="tab === 'cc'" />
      <OfficeQuestionariosTab v-else-if="tab === 'questionarios'" />
      <GerenciaEscritorio v-else-if="tab === 'gerencia'" />
      <!-- nf-import falls back to nf tab since NF import is in warehouse -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import OfficeFornecedoresTab from './OfficeFornecedoresTab.vue'
import OfficeNotasFiscaisTab from './OfficeNotasFiscaisTab.vue'
import OfficeRequisicaoCompraTab from './OfficeRequisicaoCompraTab.vue'
import OfficeOrdemCompraTab from './OfficeOrdemCompraTab.vue'
import OfficeCentroCustoTab from './OfficeCentroCustoTab.vue'
import GerenciaEscritorio from './GerenciaEscritorio.vue'
import OfficeQuestionariosTab from './OfficeQuestionariosTab.vue'

export default defineComponent({
  name: 'OfficePanel',
  components: { OfficeFornecedoresTab, OfficeNotasFiscaisTab, OfficeRequisicaoCompraTab, OfficeOrdemCompraTab, OfficeCentroCustoTab, OfficeQuestionariosTab, GerenciaEscritorio },
  props: {
    activeTab: { type: String, default: '' }
  },
  emits: ['tab-change'],
  setup(props, { emit }) {
    const tabs = ['fornecedores', 'nf', 'rc', 'oc', 'cc', 'questionarios', 'gerencia'] as const
    const tab = ref<typeof tabs[number]>('fornecedores')
    // sync with sidebar nav
    watch(() => props.activeTab, (val) => {
      if (val && (tabs as readonly string[]).includes(val)) {
        tab.value = val as typeof tab.value
      }
    }, { immediate: true })
    // avisa o DashboardView para manter a URL (/escritorio/questionario) e a sidebar em sincronia
    watch(tab, (val) => { if (val !== props.activeTab) emit('tab-change', val) })
    return { tab }
  }
})
</script>

<style scoped lang="scss">
.office-shell { width: 100%; display: flex; flex-direction: column; gap: 0; }
.office-nav {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;
  gap: 10px; margin-bottom: 24px; padding-bottom: 14px;
  border-bottom: 1px solid rgba(31,30,26,.1);
}
.office-tabs { display: flex; gap: 4px; flex-wrap: wrap; }
.office-tab {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 8px; border: none; cursor: pointer;
  background: transparent; font-size: 13px; font-weight: 500; color: var(--ink-muted, #666);
  transition: background .12s, color .12s;
  &:hover { background: rgba(31,30,26,.05); color: var(--ink, #2c2b27); }
  &.active { background: var(--system-navbar, #0f4c81); color: var(--system-navbar-text, #fff); }
}
.office-content { width: 100%; }
</style>
